import { createSlice } from "@reduxjs/toolkit";
import { AgendaModel } from "../../../models/agenda/agendaModel";
import { resetAll } from "../../actions/actions";
import { buscarAgenda } from "../../../services/agendaService";

export interface AgendaState {
  //buscar agenda
  loading: boolean;
  busca: string | null;
  list: AgendaModel[];
  entity: AgendaModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: AgendaState = {
  //buscar agenda
  loading: false,
  busca: null,
  list: [],
  entity: {} as AgendaModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const agendaCompromissoFiscalSlice = createSlice({
  name: "agendaCompromissoFiscal",
  initialState,
  reducers: {
    //buscar agenda
    setBuscaAgendaCompromissoFiscal: (state, action) => {
      state.busca = action.payload;
    },
    setEntityAgendaCompromissoFiscal: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarAgendaCompromissoFiscal: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarAgendaCompromissoFiscal: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar agenda
    builder.addCase(buscarAgenda.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarAgenda.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarAgenda.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar agenda
  setBuscaAgendaCompromissoFiscal,
  setEntityAgendaCompromissoFiscal,
  //internal
  setModalCadastrarAgendaCompromissoFiscal,
  setModalDeletarAgendaCompromissoFiscal,
} = agendaCompromissoFiscalSlice.actions;

export default agendaCompromissoFiscalSlice.reducer;
